import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { current: String, url: String }

  connect() {
    const detected = Intl.DateTimeFormat().resolvedOptions().timeZone
    if (detected === this.currentValue) return

    const token = document.querySelector('meta[name="csrf-token"]')?.content
    fetch(this.urlValue, {
      method: "PUT",
      headers: { "Content-Type": "application/json", "X-CSRF-Token": token },
      body: JSON.stringify({ time_zone: detected })
    })
  }
}
